import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';
import Global from 'models/Global';
import Session from './Session';
import '../backbone-relational-isomorphic';

var SessionsGroupCollection = Backbone.Collection.extend({

    model: Session,

    initialize: function() {
    }

});

export default SessionsGroupCollection;

